var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1555_13219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4682 1.5C24.6614 3.42109 23.9655 5.31416 22.9482 6.70564C21.8868 8.07548 20.1888 9.12323 18.5349 8.98829C18.3184 7.13976 19.1564 5.17412 20.0944 3.97488C21.1548 2.61395 22.996 1.57129 24.4682 1.5ZM31.1386 13.6627C30.9314 13.7807 27.5137 15.7254 27.5512 19.6908C27.5942 24.4802 31.9468 26.0635 32 26.0809C31.974 26.1925 31.3184 28.3659 29.6859 30.5727C28.3226 32.5156 26.8943 34.4149 24.6256 34.4496C23.5471 34.4733 22.8188 34.1777 22.06 33.8697C21.2684 33.5484 20.4435 33.2136 19.1531 33.2136C17.785 33.2136 16.9235 33.5591 16.0926 33.8924C15.3743 34.1805 14.6789 34.4595 13.6987 34.498C11.5381 34.5737 9.88732 32.4238 8.47462 30.4984C5.65053 26.5669 3.45214 19.4194 6.39981 14.5555C7.82811 12.1701 10.4324 10.634 13.2161 10.5931C14.442 10.5692 15.6177 11.0194 16.6483 11.4142C17.4365 11.716 18.1399 11.9854 18.716 11.9854C19.222 11.9854 19.9056 11.7268 20.7024 11.4254C21.9581 10.9504 23.4947 10.3691 25.0601 10.5261C26.1308 10.5559 29.1773 10.929 31.1428 13.6603L31.1386 13.6627Z",
    fill: "#3AB100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1555_13219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.87f61f59b0f93b6eca4ae5176e3c0e7d.svg";
export { ForwardRef as ReactComponent };